import { render, staticRenderFns } from "./VValidationError.vue?vue&type=template&id=71b476b6&"
import script from "./VValidationError.vue?vue&type=script&lang=ts&"
export * from "./VValidationError.vue?vue&type=script&lang=ts&"
import style0 from "./VValidationError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports